import { apiService, initPromise } from '../modules/dpopSingleton';

// Wraps DPoP response in axios-compatible shape { data, status }
const createResponse = (data) => ({ data, status: 200 });

// Wraps DPoP errors in axios-compatible shape { response: { data, status } }
const createError = (error) => {
  const axiosError = new Error(error.message);
  axiosError.response = error.response || {
    data: error.data || { message: [error.message], status_code: error.status || 500 },
    status: error.status || 500
  };
  return axiosError;
};

// Appends platform=web to URLs (matching original axiosInstance behavior)
const appendPlatform = (url) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}platform=web`;
};

// DPoP-backed adapter with same interface as axiosInstance
const axiosInstance = {
  get: async (url, config = {}) => {
    await initPromise;
    try {
      const data = await apiService.authenticatedRequest('GET', appendPlatform(url), null, {}, { showToast: false });
      return createResponse(data);
    } catch (error) {
      throw createError(error);
    }
  },
  post: async (url, body = null, config = {}) => {
    await initPromise;
    try {
      const data = await apiService.authenticatedRequest('POST', appendPlatform(url), body, {}, { showToast: false });
      return createResponse(data);
    } catch (error) {
      throw createError(error);
    }
  },
  patch: async (url, body = null, config = {}) => {
    await initPromise;
    try {
      const data = await apiService.authenticatedRequest('PATCH', appendPlatform(url), body, {}, { showToast: false });
      return createResponse(data);
    } catch (error) {
      throw createError(error);
    }
  },
  put: async (url, body = null, config = {}) => {
    await initPromise;
    try {
      const data = await apiService.authenticatedRequest('PUT', appendPlatform(url), body, {}, { showToast: false });
      return createResponse(data);
    } catch (error) {
      throw createError(error);
    }
  },
  delete: async (url, config = {}) => {
    await initPromise;
    try {
      const data = await apiService.authenticatedRequest('DELETE', appendPlatform(url), null, {}, { showToast: false });
      return createResponse(data);
    } catch (error) {
      throw createError(error);
    }
  },
};

export default axiosInstance;
